module.exports = __webpack_public_path__ + "img/bespoke70_17.49eb1e34.jpg";